
import React, { Fragment } from 'react';

const Assignee = props => {
    const {
        assignee,
        columns = []
    } = props;

    return columns.map(column => {
        const { prop, func } = column;

        const getColumnContent = () => {
            if(Array.isArray(prop)) {
                const [ prop1, prop2 ] = prop;
                return (
                    <Fragment>
                        { assignee[prop1] } <br/>
                        { assignee[prop2] }
                    </Fragment>
                );
            } else {
                return func ? func(assignee[prop]) : assignee[prop];
            }
        };

        return (
            <div key = { prop } className = 'desktop:grid-col-4'>
                { getColumnContent() }
            </div>
        );
    });
};

export default Assignee;